<template>
  <div class="exhibition-map">
    <div class="inside">
      <div class="map-container">
        <div v-if="activeMap == 'rooms'" class="active-map">
          <inline-svg 
            :src="require('../assets/images/map/map-rooms.svg')" 
            aria-label="Room Map"
          />
        </div>
        <div v-else  class="active-map">
          <inline-svg 
            :src="require('../assets/images/map/map-stops.svg')" 
            aria-label="Stop Map"
          />
        </div>
      </div>
          <!-- <div class="placeholder-map map-rooms">
            <p>Room Map TBC</p>
          </div> -->
          <!-- <div class="placeholder-map map-stops">
            <p>Stop Map TBC</p>
          </div> -->
      <div class="map-controls">
        <button
          class="button"
          @click="swapActiveMap('stops')"
          v-bind:class="{ active: activeMap == 'stops' }"
        >
          Stops
        </button>
        <button
          class="button"
          @click="swapActiveMap('rooms')"
          v-bind:class="{ active: activeMap == 'rooms' }"
        >
          Rooms
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import InlineSvg from 'vue-inline-svg';

export default {
  components: {
    InlineSvg,
  },
  data() {
    return {
      activeMap: "stops",
    };
  },
  created() {
    this.$store.dispatch("togglePlayer", false);
  },
  methods: {
    swapActiveMap(name) {
      this.activeMap = name;
    }
  }
};
</script>

<style lang="scss" scoped>

// FOR PRODUCTION: 
// Remove from here...
// .active-map {
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }
// .placeholder-map {
//   margin: 4em 0 8em 0;
//   width: 100%;
//   max-width: 280px;
//   height: 300px;
//   background-color: #d1d1d1;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }
// .map-controls {
//   display: block;
//   margin: 2em 0;
// }
// ...To here

svg {
  width: 100%;
  height: auto;
  max-height: 80vh;
}

.inside {
  padding-top: 1em;
}

.map-controls {
  background-color: white;
  border-radius: 78px;
  width: 240px;
  border: 1px solid #efefef;

  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: center;

  z-index: 100;
  position: relative;
  top: -80px;
}

.button {
  cursor: pointer;
  background-color: black;
  border-radius: 78px;
  color: white;
  // padding: 1em; // messes up buttons in Safari.
  border: 1px solid transparent;
  height: 38px;
  width: 120px;
  transition: 0.3s ease;

  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;

  @include ngv-type($exhibition_subtitle, 14px, 18px);
  color: white;
  font-weight: bold;

  &:hover {
    background-color: rgba(black, 0.8);
    border-color: rgba(black, 0.1);
  }

  &.active {
    background-color: black;
    color: white;
  }

  &:not(.active) {
    background-color: white;
    color: black;
  }
}
</style>
